import type { ErrorInfo } from 'react';

import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';
import { fg } from '@atlaskit/platform-feature-flags/fg';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import { getErrorAttributes } from '../ai-answer-dialog/get-error-attributes';
import type { commonAttributesType } from '../ai-answer-dialog/types';
import type { PersonKnowledgeCardVariant } from './on-person-knowledge-card-loaded';

interface PersonKnowledgeCardErroredProps extends commonAttributesType {
	personCardVariant: PersonKnowledgeCardVariant;
	error: unknown;
	errorInfo?: ErrorInfo;
}

export const onPersonKnowledgeCardErrored = (
	props: PersonKnowledgeCardErroredProps,
): AnalyticsEventPayload => {
	const { source, personCardVariant, error, errorInfo } = props;
	return {
		action: 'errored',
		actionSubject: 'aiAnswerPersonKnowledgeCard',
		source,
		eventType: 'operational',
		attributes: {
			...filterCommonAttributes(props),
			personCardVariant,
			...(fg('kd_sain_person_card_error_details') && getErrorAttributes(error, errorInfo)),
		},
	};
};
